import AccountService from "@/service/AccountService"
import ApplyService from "@/service/ApplyService"
import AddressService from "@/service/AddressService"
import FlowService from "@/service/FlowService"
import HelpService from "@/service/HelpService"
import LocationService from "@/service/LocationService"
import LogService from "@/service/LogService"
import SessionService from "@/service/SessionService"
import TestService from "@/service/TestService"
import WorkflowService from "@/service/WorkflowService"
import ValidationService from "@/service/ValidationService"
import NavigationService from "@/service/NavigationService"
import GoogleAnalyticsService from "@/service/GoogleAnalyticsService"
import ProveService from "@/service/ProveService"
import IovationService from "@/service/IovationService"

export const accountService = AccountService
export const applyService = ApplyService
export const addressService = AddressService
export const flowService = FlowService
export const helpService = HelpService
export const locationService = LocationService
export const logService = LogService
export const navigationService = NavigationService
export const workflowService = WorkflowService
export const googleAnalyticsService = new GoogleAnalyticsService()
export const sessionService = new SessionService()
export const testService = TestService
export const validationService = ValidationService
export const proveService = ProveService
export const iovationService = new IovationService()

